import { render, staticRenderFns } from "./BusinessMatchSharingMatchResults.vue?vue&type=template&id=6fd39128&scoped=true"
import script from "./BusinessMatchSharingMatchResults.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchSharingMatchResults.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchSharingMatchResults.vue?vue&type=style&index=0&id=6fd39128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd39128",
  null
  
)

export default component.exports